var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.43266C0 0.641875 0.662031 0 1.47812 0H18.5219C19.3383 0 20 0.641875 20 1.43266V18.5676C20 19.3586 19.3383 20 18.5219 20H1.47812C0.662109 20 0 19.3587 0 18.5678V1.43242V1.43266Z",
    fill: "#2867B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07782 16.7374V7.73329H3.08501V16.7374H6.07813H6.07782ZM4.58204 6.50415C5.62547 6.50415 6.27508 5.81274 6.27508 4.94868C6.25555 4.06493 5.62547 3.39282 4.60188 3.39282C3.57758 3.39282 2.9086 4.06493 2.9086 4.9486C2.9086 5.81267 3.55797 6.50407 4.56243 6.50407H4.5818L4.58204 6.50415ZM7.73438 16.7374H10.727V11.7096C10.727 11.4409 10.7465 11.1714 10.8256 10.9795C11.0418 10.4416 11.5342 9.88478 12.3612 9.88478C13.4438 9.88478 13.8772 10.7104 13.8772 11.9209V16.7374H16.8697V11.5747C16.8697 8.80915 15.3934 7.5222 13.4245 7.5222C11.8102 7.5222 11.1012 8.42446 10.7073 9.03899H10.7272V7.7336H7.73454C7.7736 8.57829 7.7343 16.7377 7.7343 16.7377L7.73438 16.7374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.3b15e677cc0c8adefbe889de270c41a9.svg";
export { ForwardRef as ReactComponent };